module.exports = __webpack_public_path__ + "static/img/bg_baoti@2x.d8a91a3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/newUi-icon/bg_baoti@2x.png
// module id = 9vte
// module chunks = 96